import axios from "axios";
import * as Constants from "../Constants";

class ApiService {
  constructor(token) {
    this.token = token;
    this.headers = {
      Authorization: "Bearer " + this.token,
      "Content-Type": "application/json",
      Accept: "application/json",
    };
  }

  async getTimetable() {
    try {
      const response = await axios.get(Constants.APIUrl + "/smartlogin/apps/timetable", {
        headers: this.headers,
      });

      const timetableKeys = Object.keys(response.data.timetable);
      const processedTimetableReponse = [];

      for (const key of timetableKeys) {
        const tmpResponse = [];
        const lessonKeys = Object.keys(response.data.timetable[key]["lessons"]);
        let tmpLessons = [];

        for (const lessonKey of lessonKeys) {
          tmpLessons.push(response.data.timetable[key]["lessons"][lessonKey]);
        }

        response.data.timetable[key].processed_lessons = tmpLessons;
        tmpResponse.push(response.data.timetable[key]);
        processedTimetableReponse.push(tmpResponse);
      }

      return processedTimetableReponse;
    } catch (error) {
      throw error;
    }
  }

  async getApps(schoolId) {
    try {
      const response = await axios.get(
        Constants.APIUrl + "/smartlogin/apps?school=" + schoolId,
        { headers: this.headers }
      );

      return {
        apps: response.data.apps,
        starredApps: response.data.starred,
        school: response.data.school,
        member: response.data.member,
        schools: response.data.schools,
      };
    } catch (error) {
      throw error;
    }
  }

  async getLoginLinks(schoolId) {
    try {
      const response = await axios.get(
        Constants.APIUrl + "/smartlogin/apps/loginlinks?school=" + schoolId,
        { headers: this.headers }
      );

      return {
        loginLinks: response.data.links,
        defaultLoginButtonDisabled: response.data.defaultLoginButtonDisabled === 1 || response.data.defaultLoginButtonDisabled === "1",
      };
    } catch (error) {
      throw error;
    }
  }
}

export default ApiService;
